import {CommonModule} from '@angular/common';
import {Component, EventEmitter, Input, Output} from '@angular/core';

export type GateweeStep = {
  label: string;
  disabled?: boolean;
};

@Component({
  selector: 'gatewee-stepper',
  templateUrl: './gatewee-stepper.component.html',
  styleUrls: ['./gatewee-stepper.component.css'],
  standalone: true,
  imports: [CommonModule],
})
export class GateweeStepperComponent {
  @Input() steps: readonly GateweeStep[] = [];
  @Input() activeIndex = 0;

  @Input() clickable = true;
  @Input() maxAllowedIndex: number | null = null;
  @Input() canNavigate?: (targetIndex: number, currentIndex: number) => boolean;

  @Output() activeIndexChange = new EventEmitter<number>();
  @Output() blocked = new EventEmitter<{
    targetIndex: number;
    currentIndex: number;
  }>();

  isStepDisabled(index: number): boolean {
    const hardDisabled = !!this.steps[index]?.disabled;

    const gatedByMax =
      this.maxAllowedIndex !== null && index > this.maxAllowedIndex;

    const gatedByRule =
      !!this.canNavigate && !this.canNavigate(index, this.activeIndex);

    return hardDisabled || gatedByMax || gatedByRule;
  }

  getStepState(index: number): 'done' | 'active' | 'todo' | 'disabled' {
    if (this.isStepDisabled(index)) return 'disabled';
    if (index < this.activeIndex) return 'done';
    if (index === this.activeIndex) return 'active';
    return 'todo';
  }

  onSelect(index: number): void {
    if (!this.clickable) return;

    if (this.isStepDisabled(index)) {
      this.blocked.emit({targetIndex: index, currentIndex: this.activeIndex});
      return;
    }

    this.activeIndex = index;
    this.activeIndexChange.emit(index);
  }
}
